import React, { useCallback, useMemo } from 'react';
import FilterToggleGroup, { FilterToggleRow } from '../../common/list/FilterToggleGroup';
import { CONTRACT_TYPE_ALL, CONTRACT_TYPE_OPTIONS } from '../../../utils/contractType';

// "계약 관리" 유형 칩(전체/프로젝트/유지보수) - chancemng 설계(공통 FilterToggleGroup) 적용(2026-10-22).
// CONTRACT_TYPE_OPTIONS는 그대로 재사용하되(로직/테스트 영향 없음), "전체" 점은 chancemng
// 관례대로 끈다(단일선택 토글에서는 점 없는 "전체"가 다른 화면과 일관됨).
const ContractTypeList = ({ value, onChange }) => {
  const handleClick = useCallback(
    (nextValue) => {
      if (nextValue === value) return;
      onChange?.(nextValue);
    },
    [value, onChange],
  );

  const options = useMemo(
    () =>
      CONTRACT_TYPE_OPTIONS.map((opt) => ({
        ...opt,
        id: opt.value || 'all',
        color: opt.value === CONTRACT_TYPE_ALL ? null : opt.color,
      })),
    [],
  );

  return (
    <FilterToggleRow className="contract-type-chip-list">
      <FilterToggleGroup label="유형" options={options} value={value} onChange={handleClick} />
    </FilterToggleRow>
  );
};

export default ContractTypeList;
